/**
 * @fileoverview CSS module for the InterimSuccess component which displays a success state
 * with responsive button layout and icon styling.
 *
 * @example
 * // Usage in component:
 * import styles from './InterimSuccess.module.css'
 *
 * <div className={styles.container}>
 *   <div className={styles.title_container}>
 *     <Icon className={styles.icon} />
 *     <h2>Success!</h2>
 *   </div>
 *   <div className={styles.button_container}>
 *     <Button>Continue</Button>
 *   </div>
 * </div>
 */


.container {
    position: relative;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: 16px;
}

.button_container {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
    gap: 8px;
    margin: 8px 0 0;
    flex-direction: column-reverse;
    margin-top: auto;
}

.title_container {
    display: flex;
    gap: 12px;
}

.icon {
    width: 32px;
    height: 32px;
}

.button_container button {
    width: 100%;
}

@media only screen and (min-width: 768px) {
    .button_container {
        justify-content: flex-end;
        flex-direction: row;
    }

    .button_container button {
        width: auto;
    }
}
